import { useReducer } from 'react';

const initialState = {
    scrollOffset: { x: 0, y: 0 },
    lastTouchDistance: 0,
    isScrolling: false,
    isPinchZooming: false,
    showExpansionIndicator: false,
    expansionDirection: null
};

const scrollReducer = (state, action) => {
    switch (action.type) {
        case 'SET_SCROLL_OFFSET':
            return { ...state, scrollOffset: action.payload };
        case 'UPDATE_SCROLL':
            return { 
                ...state, 
                scrollOffset: {
                    x: state.scrollOffset.x + action.payload.deltaX,
                    y: state.scrollOffset.y + action.payload.deltaY
                }
            };
        case 'SET_LAST_TOUCH_DISTANCE':
            return { ...state, lastTouchDistance: action.payload };
        case 'START_SCROLLING':
            return { ...state, isScrolling: true };
        case 'STOP_SCROLLING':
            return { ...state, isScrolling: false };
        case 'START_PINCH_ZOOM':
            return { ...state, isPinchZooming: true };
        case 'STOP_PINCH_ZOOM':
            return { ...state, isPinchZooming: false, lastTouchDistance: 0 };
        case 'SHOW_EXPANSION':
            return { 
                ...state, 
                showExpansionIndicator: true,
                expansionDirection: action.payload 
            };
        case 'HIDE_EXPANSION':
            return { 
                ...state, 
                showExpansionIndicator: false,
                expansionDirection: null 
            };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};

export const useCanvasScroll = () => {
    const [state, dispatch] = useReducer(scrollReducer, initialState);

    const actions = {
        setScrollOffset: (offset) => dispatch({ type: 'SET_SCROLL_OFFSET', payload: offset }),
        updateScroll: (deltaX, deltaY) => dispatch({ type: 'UPDATE_SCROLL', payload: { deltaX, deltaY } }),
        setLastTouchDistance: (distance) => dispatch({ type: 'SET_LAST_TOUCH_DISTANCE', payload: distance }),
        startScrolling: () => dispatch({ type: 'START_SCROLLING' }),
        stopScrolling: () => dispatch({ type: 'STOP_SCROLLING' }),
        startPinchZoom: () => dispatch({ type: 'START_PINCH_ZOOM' }),
        stopPinchZoom: () => dispatch({ type: 'STOP_PINCH_ZOOM' }),
        showExpansion: (direction) => dispatch({ type: 'SHOW_EXPANSION', payload: direction }),
        hideExpansion: () => dispatch({ type: 'HIDE_EXPANSION' }),
        reset: () => dispatch({ type: 'RESET' })
    };

    return [state, actions];
};
